<template>
    <div>
        <b-card title="" border-variant="primary">
            <div class="d-flex align-items-center justify-content-between mb-1">
                <h5 class="mb-0">Plan especifico de prevención</h5>
              <div>
                <b-button
                    v-if="can('delete_gei_children_orders')"
                    variant="outline-info mr-2"
                    @click="addRowByMaster(1)"
                    :disabled="hasMatchingDocument"
                >
                    <feather-icon
                        icon="PlusIcon"
                        size="16"
                        variant="success"
                        class="cursor-pointer "
                    />
                    Añadir registro en todas las instalaciones hijas
                </b-button>

                <b-button
                    v-if="can('delete_gei_children_contract_ee_provider')"
                    variant="outline-success"
                    @click="addRowByMaster(0)"
                    :disabled="hasMatchingDocument"
                >
                    <feather-icon
                        icon="PlusIcon"
                        size="16"
                        variant="success"
                        class="cursor-pointer "
                    />
                    Añadir registro en esta instalación
                </b-button>
              </div>

            </div>

            <form-base-document
                :documents-state-data="documents_specific_prevention"
                :documents-columns="columns"
                :documents-route="documents_by_route_specific_prevention"
                :context="'specific-prevention'"
                :create-permission="can('create_gei_children_specific_plan')"
                :delete-permission="can('delete_gei_children_specific_plan')"
            />

        </b-card>

    </div>
</template>

<script>
import {BCard, BButton} from 'bootstrap-vue'
import {mapState} from "vuex"
import formBaseDocument from "@/views/gei/children_installations/form/tabDocuments/components/base/formBaseDocument"
import {mapFields} from "vuex-map-fields"

export default {
    name: "FormContractProviderDocuments",
    components: {
        BButton,
        BCard,
        formBaseDocument
    },
    data() {
        return {
            columns: [
                {key: 'options', label: 'Acciones', sortable: false},
                {key: 'received_date', label: 'Fecha Recepción', sortable: false},
                {key: 'exam_date', label: 'Fecha Examin.', sortable: false},
                {key: 'provider_id', label: 'Proveedor', sortable: false},
                {key: 'observations', label: 'Observaciones', sortable: false},
            ],
        }
    },
    computed: {
        ...mapState('childrenInstallation', []),
        ...mapState('childrenInstallationDocuments', []),
        ...mapFields({
            documents_specific_prevention: 'childrenInstallationDocuments.documents_specific_prevention',
            documents_by_route_specific_prevention: 'childrenInstallationDocuments.documents_by_route_specific_prevention',
            child_installation: 'childrenInstallation.child_installation',
        }),
        hasMatchingDocument() {
          return this.documents_specific_prevention.some(doc => doc.empty_row === true)
        }
    },
    mounted() {
       this.context = 'specific-prevention'
      //  this.getDocumentTypes()
    },
    methods: {
        can(permission) {
            return this.$store.getters.can(permission)
        },
        createNewRow(master) {
          return {
            empty_row: true,
            received_date: null,
            exam_date: null,
            provider_id: null,
            route: `${this.child_installation.master_installation.installation_code}/${this.child_installation.gei_code}/PLAN_ESPECIFICO_PROVEEDOR`,
            observations: null,
            options: null,
            children_installation_id: this.child_installation.id,
            master: master,
          }
        },
      addRowByMaster(master) {
        const newRow = this.createNewRow(master)
        this.documents_specific_prevention.unshift(newRow)
        this.documents_specific_prevention.editedRow = newRow
      }
    }

}
</script>